import { createFileRoute } from '@tanstack/react-router';
import { ActivitiesTable } from './../../../../features/quotation/activities/table';
import { getActivitiesOptions } from './../../../../features/quotation/activities/queryOptions';
import { validateSearch } from './../../../../utils/pagination';

export const Route = createFileRoute(
  '/_authenticated/quotations/$guid/_layout/activities',
)({
  component: Page,
  loaderDeps: ({ search: { page } }) => ({ page }),
  loader: ({ context: { queryClient }, deps: { page }, params: { guid } }) =>
    queryClient.ensureQueryData(getActivitiesOptions(guid, { page })),
  validateSearch: validateSearch,
});

export function Page() {
  const data = Route.useLoaderData();

  return (
    <div className="col-span-full">
      <ActivitiesTable activities={data} />
    </div>
  );
}
